/**
 * Get Quote Page Component
 * 
 * This page displays a quote request form for potential customers
 * Includes a banner, introduction text, and quote form
 */

// ==================== EXTERNAL DEPENDENCIES ====================
import React from "react"
import { Container, Grid } from "@material-ui/core"

// ==================== INTERNAL COMPONENTS ====================
// Layout & SEO Components
import Layout from "../components/theme/layout"
import SEO from "../components/theme/seo"

// Page Section Components
import Banner from "../components/banner"
import Onecol from "../components/onecol"

// Form Components
import Quote from "../components/form/quote"

// ==================== ASSETS ====================
import QBanner from "../images/quote-banner.jpg"

// ==================== COMPONENT DEFINITION ====================
/**
 * GetQuote Page Component
 * Renders the quote request page with form and supporting content
 */
const GetQuote = () => (
  <Layout>
    {/* SEO Meta Data */}
    <SEO
      title="Get a Quote"
      description="Fill out the form below & let us know what you need. We'll get back to you as soon as possible."
    />

    {/* Hero Banner Section */}
    <Banner 
      title="Get a Quote" 
      img={QBanner} 
    />

    {/* Introduction Section */}
    <Onecol
      title="We would love the opportunity to assist you"
      description="Please fill in the form below with and we will contact you as soon as possible."
    />

    {/* Quote Form Section */}
    <Container className="pb-40">
      <Grid container className="flex justify-center">
        <Grid item className="form quote max-auto">
          <Quote />
        </Grid>
      </Grid>
    </Container>
  </Layout>
)

// ==================== EXPORTS ====================
export default GetQuote